import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'c-core-sidebar',
  templateUrl: './core-sidebar.component.html',
  styleUrls: ['./core-sidebar.component.scss']
})
export class CoreSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
